import React from 'react'
import VolumeOff from 'material-ui/svg-icons/av/volume-off'
import VolumeOn from 'material-ui/svg-icons/av/volume-up'

export function MuteUnMuteButton (props) {
  const {onMouseEnter, style, onClick, mute} = props

  return (
    <button
      onMouseEnter={onMouseEnter}
      className='front_pannel fa fa-volume-up'
      style={style}
      onClick={onClick}>
      {mute ? <VolumeOff style={{color: '#f6fffe'}}/> : <VolumeOn style={{color: '#f6fffe'}}/>}
    </button>
  )
}




// WEBPACK FOOTER //
// ./src/routes/SeminarMode/MuteUmuteButton.jsx